import React, { Component } from "react";
//import TableComp from '../../../../components/_utils/table'
import { TableComp } from "sz-react-utils";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";

import {
  Button,
  Card,
  Col,
  notification,
  Popconfirm,
  Row,
  Tooltip,
  Switch,
} from "antd";
import Request from "../../../../request";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import styles from "../../country/all/styles.less";

import rightAuth from "../../../../components/_utils/userRights";
import { RightsWrapper } from "../../../../components/_utils/utils";

class AllBranch extends Component {
  state = {
    count: 0,
    exportLoading: false,
    isActive:true
  };

  constructor(props) {
    super(props);

    this.table = React.createRef();
  }
  onOk = value => {
    this.table.current.reload()
}

  exportExcel = async () => {
    const { exportParams } = this.state;

    this.setState({ exportLoading: true });
    let x = await Request.exportBranchesToExcel({
      ...exportParams,
      regExFilters: ["branchName"],
    });
    this.setState({ exportLoading: false });

    if (!x.error) {
      window.open(x.url);
    }
  };

  changeBranchStatus = async ({ checked, _id }) => {
    await Request.changeBranchStatus({
      _id,
      status: checked,
    });
    this.table.current.reload();
  };

  changeBranchRightTOViewChannelPartner = async ({ checked, _id }) => {
    await Request.changeBranchRightTOViewChannelPartner({
      _id,
      showChannelPartner: checked,
    });
    this.table.current.reload();
  }
  changeBranchRightTOShowStaffToOtherBranch = async ({ checked, _id }) => {
    await Request.changeBranchRightTOShowStaffToOtherBranch({
      _id,
      showStaffToOtherBranch: checked,
    });
    this.table.current.reload();
  }

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      params.branchAssociatePartner = "Branch"
      if(this.state.isActive) {
        params.status = true
      }
      this.setState({ exportParams: params });
      let data = await Request.loadBranch({
        ...params,
        regExFilters: ["branchName"],
      });

      this.setState({ count: data.total });

      resolve(data);
    });
  };

  componentDidMount() { }

  renderStatus = (val) => {
    if (val) {
      return <div className={styles.Potential}>YES</div>;
    } else {
      return <div className={styles.Cold}>NO</div>;
    }
  };

  handleDelete = async (val) => {
    Request.deleteBranch(val)
      .then((x) => {
        if(x.msg === "You cannot delete because user assigned for this branch") {
          let promptResponse = prompt("Are you sure to delete branch because user assigned for this branch? Yes OR No ")
          if(promptResponse.toLowerCase() === "yes") {
             Request.deleteBranchUsers({branchId:val}).then((response)=>{
              if(response.success) {
                notification.success({
                  message: response.msg,
                  description: response.msg,
                });
              }else {
                notification.error({
                  message: "Error",
                  description: response.msg,
                });
              }
             })
          }
        }
        this.table.current.reload();
        // if (x.success) {
        //   notification.success({
        //     message: x.msg,
        //     description: x.msg,
        //   });
        // } else {
        //   notification.error({
        //     message: "Error",
        //     description: x.msg,
        //   });
        // }
        
      })
      .catch((err) => {
        notification.error({
          message: "Error",
          description: "Some Error",
        });
      });
  };

  render() {

    const columns = [
      {
        title: "Branch",
        key: "branchName",
        dataIndex: "branchName",
        width: 100,
        fixed: "left",
        sorter: true,
        searchTextName: "branchName",
        filterRegex: true,
        render: (val, record) => {
          return <React.Fragment>
            {rightAuth.checkRights("Branch.edit") ? <RightsWrapper myRight={"Branch.edit"}>
              <Tooltip title="Click To Edit Details">
                <a href={`/master/edit-branch?_id=${record._id}`}>
                  {record.branchName}
                </a>
              </Tooltip>
            </RightsWrapper> : <React.Fragment>
              {record.branchName}
            </React.Fragment>}
          </React.Fragment>;
        },
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 70,
        render: (val, record) => {
          return (
            <div className={styles.wrap}>
              <Switch
                checked={record.status}
                onChange={(checked) => {
                  this.changeBranchStatus({
                    checked,
                    _id: record._id,
                  });
                }}
              />
            </div>
          );
        },
      },
      {
        title: "Show Channel Partner",
        dataIndex: "showChannelPartner",
        key: "showChannelPartner",
        width: 70,
        render: (val, record) => {
          return (
            <div className={styles.wrap}>
              <Switch
                checked={record.showChannelPartner}
                onChange={(checked) => {
                  this.changeBranchRightTOViewChannelPartner({
                    checked,
                    _id: record._id,
                  });
                }}
              />
            </div>
          );
        },
      },
      {
        title: "Show Staff To Other Branch",
        dataIndex: "showStaffToOtherBranch",
        key: "showStaffToOtherBranch",
        width: 70,
        render: (val, record) => {
          return (
            <div className={styles.wrap}>
              <Switch
                checked={record.showStaffToOtherBranch}
                onChange={(checked) => {
                  this.changeBranchRightTOShowStaffToOtherBranch({
                    checked,
                    _id: record._id,
                  });
                }}
              />
            </div>
          );
        },
      },

      {
        title: "State Head",
        key: "isStateHead",
        width: 80,
        dataIndex: "isStateHead",
        render: (val, record) => {
          return this.renderStatus(val);
        },
      },
      {
        title: "City",
        key: "city",
        width: 80,
        dataIndex: "city",
        render: (val, record) => {
          return (
            <div>{record.branchCityId ? record.branchCityId.cityName : ""}</div>
          );
        },
      },
      // {
      //   title: "Plan",
      //   key: "plan",
      //   width: 80,
      //   dataIndex: "plan",
      //   render: (val, record) => {
      //     return (
      //       <div>{record.plan ? record.plan.planName : ""}</div>
      //     );
      //   },
      // },
      {
        title: "State",
        key: "state",
        width: 80,
        dataIndex: "state",
        render: (val, record) => {
          return (
            <div>
              {record.branchStateId ? record.branchStateId.stateName : ""}
            </div>
          );
        },
      },
      {
        title: "Country",
        key: "country",
        width: 80,
        dataIndex: "country",
        render: (val, record) => {
          return (
            <div>
              {record.branchCountryId ? record.branchCountryId.countryName : ""}
            </div>
          );
        },
      },
      {
        title: "Branch Phone",
        key: "branchHeadPhone",
        dataIndex: "branchHeadPhone",
        render: (val, record) => {
          return (
            <div>
              <small>Head:{record.branchHeadPhone}</small>
              <div />
              <small>Branch:{record.branchPhone1}</small>
            </div>
          );
        },
      },
      {
        title: "Branch Email",
        key: "branchHeadEmail",
        dataIndex: "branchHeadEmail",
      },
      {
        title: "Action",
        key: "operation",
        width: 100,
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={"Branch.delete"}>
              <Tooltip title="Delete Branch">
                <Popconfirm
                  title="Are you sure to delete Branch?"
                  onConfirm={() => this.handleDelete(record._id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button shape="circle" className={styles.btn} icon="delete" />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        ),
      },
    ];
    return (
      <PageHeaderWrapper title={`Total Branches : ${this.state.count}`}>
        <Card style={{ marginBottom: 10 }}>
          <Row>
            <div>
            
            </div>
            <Col span={12}>
              {
                rightAuth.checkRights("BranchExcelExport.view") ?
                  <Button
                    type={"default"}
                    loading={this.state.exportLoading}
                    onClick={() => {
                      this.exportExcel();
                    }}
                  >
                    Export Excel
                  </Button>
                  : null
              }
              
            </Col>
            <Col span={10}>
            </Col>
            <Col span={2}>
              <div style={{ textAlign: 'right', marginTop: '15px' }}>
                <Link to='/master/add-branch'><Button>Add</Button></Link>
              </div>
            </Col>
          </Row>
        </Card>
        <Card bordered={true}>
        <Button
              style={{marginLeft:'10px'}}
              className={styles.btn1}
              type="primary"
              onClick={() => {
                this.state.isActive = !this.state.isActive
                this.setState({isActive: this.state.isActive})
                this.onOk()
                }}> {this.state.isActive ? 'All Branches' : 'Active Branches'}
            </Button>
          <TableComp
            columns={columns}
            ref={this.table}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 1200 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 20,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllBranch);
